import {CloseIcon} from '@/components/Icons';
import {getGlobalButtons} from '@/services/content/appContent';
import {twx} from '@/utils/tailwindUtils';

import ButtonRaw from './ButtonRaw';

type CloseButtonProps = React.ComponentProps<typeof ButtonRaw> & {
    icon?: React.ReactNode;
    alt?: string;
};

const CloseButton = ({className, icon, alt, ref, ...restProps}: CloseButtonProps) => (
    <ButtonRaw
        ref={ref}
        data-testid='close-button'
        className={twx(
            'flex h-11 w-11 items-center justify-center rounded-full border-0 bg-transparent p-0 outline-none',
            className
        )}
        aria-label={alt ?? getGlobalButtons().closeButton?.alt ?? undefined}
        {...restProps}
    >
        {icon ?? <CloseIcon />}
    </ButtonRaw>
);

CloseButton.displayName = 'CloseButton';

export default CloseButton;
